import APIClient from '../../../lib/api';

const DEFAULT_PAGE_SIZE = 25;

class QuoteService {
  async getAll(params = {}) {
    const defaultParams = {
      skip: 0,
      limit: DEFAULT_PAGE_SIZE,
    };

    const queryParams = { ...defaultParams, ...params };

    try {
      const response = await APIClient.quotes.getAll(queryParams);
      return {
        success: true,
        data: Array.isArray(response.data) ? response.data : response.data?.data || [],
        total: response.data?.total ?? response.data?.length ?? 0,
      };
    } catch (error) {
      console.error('QuoteService.getAll error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης προσφορών',
      };
    }
  }

  async getById(quoteId) {
    try {
      const response = await APIClient.quotes.getById(quoteId);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('QuoteService.getById error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης προσφοράς',
      };
    }
  }

  async create(payload) {
    try {
      const response = await APIClient.quotes.create(payload);
      return {
        success: true,
        data: response.data,
        message: 'Η προσφορά δημιουργήθηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuoteService.create error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα δημιουργίας προσφοράς',
        errorResponse: error.response?.data,
      };
    }
  }

  async update(quoteId, payload) {
    try {
      const response = await APIClient.quotes.update(quoteId, payload);
      return {
        success: true,
        data: response.data,
        message: 'Η προσφορά ενημερώθηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuoteService.update error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης προσφοράς',
      };
    }
  }

  async delete(quoteId) {
    try {
      await APIClient.quotes.delete(quoteId);
      return {
        success: true,
        message: 'Η προσφορά διαγράφηκε επιτυχώς',
      };
    } catch (error) {
      console.error('QuoteService.delete error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα διαγραφής προσφοράς',
      };
    }
  }

  async addItem(quoteId, payload) {
    try {
      const response = await APIClient.quotes.addItem(quoteId, payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('QuoteService.addItem error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα προσθήκης υπηρεσίας',
      };
    }
  }

  async updateItem(quoteId, itemId, payload) {
    try {
      const response = await APIClient.quotes.updateItem(quoteId, itemId, payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('QuoteService.updateItem error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα ενημέρωσης υπηρεσίας',
      };
    }
  }

  async deleteItem(quoteId, itemId) {
    try {
      await APIClient.quotes.deleteItem(quoteId, itemId);
      return {
        success: true,
        message: 'Η υπηρεσία αφαιρέθηκε από την προσφορά',
      };
    } catch (error) {
      console.error('QuoteService.deleteItem error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα αφαίρεσης υπηρεσίας',
      };
    }
  }

  async downloadPDF(quoteId) {
    try {
      const response = await APIClient.quotes.generatePDF(quoteId);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      return {
        success: true,
        data: {
          url,
          blob,
        },
      };
    } catch (error) {
      console.error('QuoteService.downloadPDF error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα δημιουργίας PDF',
      };
    }
  }

  async getPreviewHTML(quoteId) {
    try {
      const response = await APIClient.quotes.getPreviewHTML(quoteId);
      return {
        success: true,
        data: response.data?.html || '',
      };
    } catch (error) {
      console.error('QuoteService.getPreviewHTML error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message || 'Σφάλμα φόρτωσης preview',
      };
    }
  }

  formatCurrency(amount) {
    const value = Number(amount || 0);
    return new Intl.NumberFormat('el-GR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  formatStatus(status) {
    const statusMap = {
      draft: 'Πρόχειρο',
      sent: 'Απεσταλμένο',
      accepted: 'Εγκεκριμένο',
      rejected: 'Απορρίφθηκε',
      expired: 'Έληξε',
    };
    return statusMap[status] || status;
  }

  getStatusColor(status) {
    const statusColors = {
      draft: 'default',
      sent: 'info',
      accepted: 'success',
      rejected: 'error',
      expired: 'warning',
    };
    return statusColors[status] || 'default';
  }
}

const quoteService = new QuoteService();
export default quoteService;

